import axios from '@/libs/http'

/**
 * 获取动态列表
 */
export const getPostList = (isPublish, pageNo, pageSize) => {
    return axios.request({
        url: '/s/c/post/list',
        params: {
            isPublish,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}
/**
 * 获取申请次数
 * @returns {*}
 */
export const getApplyCount = () => {
    return axios.request({
        url: '/s/c/post/getApplyCount',
        method: 'get'
    })
}
/**
 * 获取动态信息
 * @returns {*}
 */
export const getPostInfo = (id) => {
    return axios.request({
        url: '/s/c/post/getPostInfo',
        params:{
            id
        },
        method: 'get'
    })
}

/**
 * 修改动态
 */
export const updatePost = (clerkPostCheckId,content, photoUrls, videoUrl, audioUrl) => {
    let data = new URLSearchParams()
    data.append("clerkPostCheckId", clerkPostCheckId)
    data.append("content", content)
    if(photoUrls.length > 0){
        data.append("photoUrls", JSON.stringify(photoUrls))
    }
    if(videoUrl.length > 0){
        data.append("videoUrl", JSON.stringify(videoUrl[0]).replace(/^"(.*)"$/, '$1'))
    }
    if(audioUrl != null){
        data.append("audioUrl", audioUrl)
    }
    return axios.request({
        url: '/s/c/post/update',
        data,
        method: 'post'
    })
}


/**
 * 添加动态
 */
export const addPost = (content, photoUrls, videoUrl, audioUrl) => {
    let data = new URLSearchParams()
    data.append("content", content)
    if(photoUrls.length > 0){
        data.append("photoUrls", JSON.stringify(photoUrls))
    }
    if(videoUrl.length > 0){
        data.append("videoUrl", JSON.stringify(videoUrl[0]))
    }
    if(audioUrl != null){
        data.append("audioUrl", audioUrl)
    }
    return axios.request({
        url: '/s/c/post/add',
        data,
        method: 'post'
    })
}

/**
 * 删除动态
 */
export const deletedPost = (postId) => {
    let data = new URLSearchParams()
    data.append("id", postId)
    return axios.request({
        url: '/s/c/post/delete',
        data,
        method: 'post'
    })
}

/**
 * 获取店员动态详情
 */
export const getClerkPostInfo = (clerkPostId) => {
    return axios.request({
        url: '/s/c/post/getClerkPostInfo',
        params: {
            clerkPostId
        },
        method: 'get'
    })
}
